


export const listMenu = [
  "Express",
  "Logistics",
  // "Brands"
];

export const expressMenu = [
  {
    name: "Domestic",
    img: "/Home/domestic.svg",
    link: "/domestic",
  },
  {
    name: "International",
    img: "/Home/international.svg",
    link: "/international",
  },
  {
    name: "E-com",
    img: "/Home/ecom.svg",
    link: "/ecom-solution",
  },
  {
    name: "Travel & Tours",
    img: "/Home/traveltours.svg",
    link: "/intiana-travel",
  },
  {
    name: "Visatronix",
    img: "/Home/visatronix.svg",
    link: "/visatronix",
  },
  {
    name: "Financial Services",
    img: "/Home/financial.svg",
    link: "/financial-services",
  },
  {
    name: "Mailroom Management",
    img: "/Home/mms.svg",
    link: "/mms",
  },
  {
    name: "Aviation",
    img: "/Home/aviation.svg",
    link: "/aviation",
  },
  
];
// export const internationalMenu 
export const  logisticsMenu = [
  {name: "Overland",
    img: "/Home/overlandexpress.svg",
    link: "overland-logistics",
  },
  {name: "Fleet & Transportation",
    img: "/Home/fleettransportation.svg",
    link: "/fleet-transportation",
  },
  {
    name: "Warehousing",
    img: "/Home/warehousing.svg",
    link: "/warehousing",
  },
  {
    name: "Distribution",
    img: "/Home/domestic/express.svg",
    link: "/distribution",
  },
  {name: "International Freight",
    img: "/Home/internatinalfreight.svg",
    link: "/international-freights",
  
  },
  {name: "Customs Brokerage",
    img: "/Home/customsbrokrage.svg",
    link: "/customs-bokerage",
  },
  {
    name: "PackNGo",
    img: "/Home/packgo.svg",
    link: "/pack-n-go",
  },
  {
    name: "Expo Logistics",
    img: "/Home/expologistics.svg",
    link: "/expo-logistics",
  },
  {
    name: "Project Logistics",
    img: "/Home/projectlogistics.svg",
    link: "/project-logistics",
  },
  // {
  //   name: "Visatronix",
  //   img: "/Home/visatronix.svg",
  //   link: "/visatronix",
  // },
  {name: "Cold Chain",
    img: "/Home/coldchain.svg",
    link: "/coldchain",
  },
  {name: "Agri Logistics",
    img: "/Home/agrilogistics.svg",
    link: "/agri-logistics",
  },
  {name: "Regional Trade",
    img: "/Home/tir.svg",
    link: "/regional-trade",
  },


  
];
// export const supplychainMenu
export const brandsMenu = [
  {
    name: "Sentiments",
    img: "/Home/sentiments.svg",
    link: "https://sentimentsexpress.com/",
   
  },
  {
    name: "Studio by TCS",
    img: "/Home/studio.svg",
    link: "https://www.studiobytcs.com/",
   
    
  },
  {
    name: "Octara",
    img: "/Home/octara.svg",
    link:  "https://octara.com/",
    
  },
  
];



export const valueAddedServicesMenu = [
  {
    name: "Digital Printing",
    img: "/Home/valueAddedServices/digital.svg",
    link: "/value-added-services/digital-printing",
  },
  {
    name: "Financial Services",
    img: "/Home/valueAddedServices/financial.svg",
    link: "/value-added-services/financial-services",
  },
  
  {
    name: "Travel & Tours",
    img: "/Home/valueAddedServices/travelAndTour.svg",
    link: "/value-added-services/travel-and-tour",
  },
  
  
];

